import {Component, Inject, OnInit} from '@angular/core';
import {DateAdapter} from '@angular/material/core';
import {MatDialogRef, MAT_DIALOG_DATA, MatDialog} from '@angular/material/dialog';
import {finalize, Observable} from 'rxjs';
import {SitePublicService} from 'src/app/services/site-public.service';
import {ConfirmComponent} from 'src/app/shared/dialogs/confirm/confirm.component';
import {SnackBarIconService} from 'src/app/shared/snack-bar-icon/snack-bar-icon.service';
import {MatTableDataSource} from '@angular/material/table';
import {AngularFireUploadTask} from '@angular/fire/compat/storage';
import {FileManagerService} from 'src/app/shared/file-manager/file-manager.service';
import {SpinnerService} from 'src/app/shared/waiting/spinner.service';
import {BulletinPdfDialogComponent} from '../bulletin-pdf-dialog/bulletin-pdf-dialog.component';

@Component({
  selector: 'app-bulletin-list-dialog',
  templateUrl: './bulletin-list-dialog.component.html',
  styleUrls: [ './bulletin-list-dialog.component.scss' ]
})
export class BulletinListDialogComponent implements OnInit {

  public gallery$!: Observable<any[]>;
  public roles: any;
  public title: string = "";
  public members: any[] = []

  public editItem: boolean = false;

  public dataSource: MatTableDataSource<any>
  public displayedColumns: string[] = [  'name', 'file', 'preview', 'edit', 'delete' ];

  uploadTask: AngularFireUploadTask | undefined;
  uploadProgress: Observable<number | undefined> | undefined;
  downloadURL: string | null = null;
  isUploading = false;
  uploadError: string | null = null;

  constructor (
    public matDialogRef: MatDialogRef<BulletinListDialogComponent>,
    private _adapter: DateAdapter<any>,
    private _sitePublicService: SitePublicService,
    private _snackBar: SnackBarIconService,
    private _dialog: MatDialog,
    private _spinnerService: SpinnerService,
    private _fileManagerService: FileManagerService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    console.log("dialog data: " + JSON.stringify(this.data));
    this.title = this.data.year
    console.log("title: " + this.title)
  }

  ngOnInit () {
    this._adapter.setLocale('pt');
    this.getBulletins(this.data.id);
  }

  async getBulletins (id: any) {
    this.gallery$ = this._sitePublicService.loadBulletinPDFs(id);
    this.gallery$.subscribe(images => {
      //console.log("pages updated:" + JSON.stringify(pages));
      this.dataSource = new MatTableDataSource(images);
    });
  }

  openPDFDialog (entity: any) {

    let data: any = {};
    if (entity) {
      data = {'id': entity.id, 'name': entity.name, 'src': entity.src, 'text': entity.text, 'file': entity.file};
    } else {
      data = {'id': '0', 'name': '', 'src': '', 'text': '', 'file': ''};
    }

    // console.log("openPhotoDialog: " + JSON.stringify(data))

    let dialogRef = this._dialog.open(BulletinPdfDialogComponent, {
      width: '500px',
      height: '370px',
      panelClass: 'custom-dialog-container',
      data: data
    });

    dialogRef.afterClosed()
      .subscribe(async (response) => {
        if (!response) {
          return;
        }

        const actionType: string = response[ 0 ];
        const form: any = response[ 1 ];
        const selectedFile: any = response[ 2 ];
        const formData = form.getRawValue();
        const bulletin_id = this.data.id;

        if (actionType == 'insert') {
          console.log("bulletin_id: " + bulletin_id)
          console.log("insert: " + JSON.stringify(formData))

          this._sitePublicService.insertBulletinPDF(bulletin_id, formData)
            .then((result) => {
              this._snackBar.openSnackBar("Sucesso!", '', 'success')
              if (selectedFile) {
                this.startUpload(bulletin_id, result.id, selectedFile);
              } else {
                this._snackBar.openSnackBar("Sucesso!", '', 'success')
              }
            })
            .catch((err: any) => {
              this._snackBar.openSnackBar("Erro!", '', 'error')
            })

        } else if (actionType == 'update') {
          console.log("bulletin_id: " + this.data.id)
          console.log("update: " + JSON.stringify(formData))

          const pdf_id = formData.id;

          this._sitePublicService.updateBulletinPDF(bulletin_id, pdf_id, formData)
            .then(() => {
              this._snackBar.openSnackBar("Sucesso!", '', 'success')
              if (selectedFile) {
                this._sitePublicService.deleteFileInStorage(data.src)
                this.startUpload(bulletin_id, pdf_id, selectedFile);
              } else {
                this._snackBar.openSnackBar("Sucesso!", '', 'success')
              }
            })
            .catch((err: any) => {
              console.log("erro: " + err.message)
              this._snackBar.openSnackBar("Erro!", '', 'error')
            })

        }

      })


  }

  deletePDF (element: any) {
    let dialogRef = this._dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: {title: "Confirme", message: element.name + "<br><br>Excluir esta imagem?"}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {

        this._sitePublicService.deleteFileInStorage(element.src)

        this._sitePublicService.deleteBulletinPDF(this.data.id, element.id)
          .then(() => {
            this._snackBar.openSnackBar("Sucesso!", '', 'success')
          })
          .catch((err) => {
            this._snackBar.openSnackBar("Erro!", '', 'error')
          })
      }
    })
  }

  startUpload (bulletin_id: string, pdf_id: string, selectedFile: any): void {

    const waiting = this._spinnerService.show();

    this._fileManagerService.storage_path = "site_pub/bulettin/" + bulletin_id;

    this.isUploading = true;
    this.uploadError = null;
    this.downloadURL = null;

    const {task, downloadURL$} = this._fileManagerService.uploadFile(selectedFile);
    this.uploadTask = task;

    // Acompanhar o progresso
    this.uploadProgress = this.uploadTask.percentageChanges();

    // Obter o URL de download e finalizar
    downloadURL$.pipe(
      finalize(() => {
        this.isUploading = false;
        this.uploadTask = undefined;
      })
    ).subscribe({
      next: (url) => {
        if (url) {
          this.downloadURL = url;
          this._sitePublicService.updateBulletinPDF(bulletin_id, pdf_id, {src: url})
            .then(() => {
              console.log("upload image bulletin success")
            })
            .catch((err) => {
              console.log("erro upload bulletin image")
            })
            .finally(() => {
              waiting.close();
            })

        }
      },
      error: (err) => {
        this.uploadError = 'Erro no upload: ' + (err.message || 'Desconhecido');
        console.error('Erro no upload:', err);
      }
    });
  }

}

